import { NgModule } from '@angular/core';
import { UserFoldersStoreModule } from './store/user-folders-store.module';

@NgModule({
    imports: [UserFoldersStoreModule],
    exports: [UserFoldersStoreModule]
})
export class UserFoldersLibModule {}
